export const emailTextContent = {
  // btnText: "sales@gammastack.com",
  email: "mailto:sales@gammastack.com",
  brandLogo: "/assets/brand-logo/Brand-Logo.svg",
  knowMoreBtnText: "More Games",
  btnText: (<img src="/assets/svg-img/email-label-img.svg" alt="Img" />),
};
